<script>
  import { onMount, getContext } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import { SEARCH_LEADERS } from '../../graphql/leaders';

  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';

  export let label;
  export let value;

  let search = '';
  let query = client.watchQuery({
    query: SEARCH_LEADERS,
    variables: { search, limit: 100 }
  });
  let results = { loading: true };

  function setResponse({ data, loading, error, networkStatus }) {
    results = {
      loading,
      page: data && data.leaders ? data.leaders.page : 1,
      total: data && data.leaders ? data.leaders.total : 0,
      leaders: data && data.leaders ? data.leaders.docs : []
    };
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({ error, loading: false });
    }
  });
</script>

<div>
  {#if label}<label>{label}</label>{/if} {#if results.loading}
  <Loader></Loader>
  {/if} {#if !results.loading}
  <select class:placeholder="{!value}" bind:value>
    <option value="{null}">Choose an Event Leader</option>
    {#each results.leaders as leader, i}
    <option value="{leader.id}">
      {leader.firstName} {leader.lastName}
    </option>
    {/each}
  </select>
  {/if}
</div>
